import { DriverProgress, Reward } from '../types/tombola'
import { WalletData } from '../types/wallet'

export const driverData: DriverProgress = {
  name: 'Moussa',
  tickets: 24,
  rides: 690,
  level: 'Bronze',
  nextLevelTickets: 40,
  nextLevelRides: 700,
  badges: [
    {
      id: 'first-ride',
      name: 'Première Course',
      description: 'Complète ta première course',
      icon: '🚗',
      unlocked: true,
      unlockedAt: new Date('2024-01-15'),
    },
    {
      id: 'early-bird',
      name: 'Lève-tôt',
      description: 'Course avant 7h',
      icon: '🌅',
      unlocked: true,
      unlockedAt: new Date('2024-01-18'),
    },
    {
      id: 'night-owl',
      name: 'Oiseau de nuit',
      description: 'Course après 22h',
      icon: '🌙',
      unlocked: true,
      unlockedAt: new Date('2024-01-19'),
    },
    {
      id: 'perfect-day',
      name: 'Journée parfaite',
      description: 'Tous les objectifs quotidiens complétés',
      icon: '⭐',
      unlocked: true,
      unlockedAt: new Date('2024-01-20'),
    },
    {
      id: 'weekend-warrior',
      name: 'Guerrier du weekend',
      description: '10 courses le weekend',
      icon: '💪',
      unlocked: false,
    },
    {
      id: 'perfect-week',
      name: 'Semaine parfaite',
      description: 'Tous les objectifs hebdomadaires complétés',
      icon: '🏆',
      unlocked: false,
    },
    {
      id: 'speed-demon',
      name: "Rapide comme l'éclair",
      description: '20 courses en une journée',
      icon: '⚡',
      unlocked: false,
    },
    {
      id: 'champion',
      name: 'Champion',
      description: 'Atteindre le niveau Gold',
      icon: '👑',
      unlocked: false,
    },
  ],
  objectives: [
    {
      id: 'daily-1',
      title: "Complète 10 courses aujourd'hui",
      current: 8,
      target: 10,
      completed: false,
      type: 'daily',
    },
    {
      id: 'daily-2',
      title: 'Accepte 15 courses consécutives',
      current: 15,
      target: 15,
      completed: true,
      type: 'daily',
    },
    {
      id: 'weekly-1',
      title: 'Gagne 50 tickets cette semaine',
      current: 24,
      target: 50,
      completed: false,
      type: 'weekly',
    },
    {
      id: 'weekly-2',
      title: 'Complète 60 courses cette semaine',
      current: 42,
      target: 60,
      completed: false,
      type: 'weekly',
    },
  ],
}

export const rewards: Reward[] = [
  {
    id: 'moto',
    title: 'Moto',
    description: 'Tirage hebdomadaire',
    icon: '🏍️',
    level: 'Diamond',
  },
  {
    id: 'fuel-card',
    title: 'Carte carburant',
    description: '50 000 FCFA',
    icon: '⛽',
    level: 'Gold',
  },
  {
    id: 'cash-bonus',
    title: 'Bonus cash',
    description: '25 000 FCFA',
    icon: '💰',
    level: 'Silver',
  },
  {
    id: 'earpods',
    title: 'EarPods',
    description: 'Écouteurs sans fil',
    icon: '🎧',
    level: 'Bronze',
  },
]

export const walletData: WalletData = {
  wallet: {
    balance: 45750,
    currency: 'FCFA',
    userId: 'moussa-123',
    qrCode: 'WALLET-MOUSSA-123-QR',
  },
  transactions: [
    {
      id: 'txn-1',
      type: 'received',
      amount: 5000,
      timestamp: new Date('2024-01-22T14:30:00'),
      senderName: 'Amadou K.',
      status: 'completed',
      description: 'Paiement course',
    },
    {
      id: 'txn-2',
      type: 'sent',
      amount: 2500,
      timestamp: new Date('2024-01-22T10:15:00'),
      recipientName: 'Fatou D.',
      status: 'completed',
      description: 'Remboursement',
    },
    {
      id: 'txn-3',
      type: 'topup',
      amount: 20000,
      timestamp: new Date('2024-01-21T16:45:00'),
      status: 'completed',
      description: 'Recharge portefeuille',
    },
    {
      id: 'txn-4',
      type: 'received',
      amount: 3500,
      timestamp: new Date('2024-01-21T09:20:00'),
      senderName: 'Ibrahim S.',
      status: 'completed',
      description: 'Paiement course',
    },
    {
      id: 'txn-5',
      type: 'sent',
      amount: 8000,
      timestamp: new Date('2024-01-20T18:30:00'),
      recipientName: 'Mariama B.',
      status: 'completed',
      description: 'Transfert',
    },
    {
      id: 'txn-6',
      type: 'received',
      amount: 4200,
      timestamp: new Date('2024-01-20T12:10:00'),
      senderName: 'Youssouf T.',
      status: 'completed',
      description: 'Paiement course',
    },
    {
      id: 'txn-7',
      type: 'topup',
      amount: 15000,
      timestamp: new Date('2024-01-19T08:00:00'),
      status: 'completed',
      description: 'Recharge portefeuille',
    },
    {
      id: 'txn-8',
      type: 'received',
      amount: 6550,
      timestamp: new Date('2024-01-18T15:40:00'),
      senderName: 'Awa M.',
      status: 'completed',
      description: 'Paiement course',
    },
  ],
}
